<template>
    <span v-if="mostrarBtnDetalheReprovacao">
        <span class="text-primary ml-1">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Detalhe da Reprovacao"
                @click.stop="mostrarDetalheReprovacao()"
            ></i>
        </span>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModalDetalheReprovacao"
        >
            <div slot="modal-title">
                Registro de Pagamento - Detalhe da Reprovação
            </div>
            <b-row>
                <b-col sm="12" v-if="pagamento.categoriaReprovacao != null">
                    <b-form-group>
                        <label>
                            Categoria da reprovação
                        </label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="pagamento.categoriaReprovacao"
                                :disabled="true"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="pagamento.detalheReprovacao != null">
                    <b-form-group>
                        <label for="contato">Justificativa</label>
                        <b-form-textarea
                            v-model="pagamento.detalheReprovacao"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheReprovacao()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModalDetalheReprovacao: false
        }
    },

    methods: {
        mostrarDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = true
        },

        fecharDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = false
        }
    },

    computed: {
        mostrarBtnDetalheReprovacao() {
            return (
                this.pagamento.status === pagamentoStatus.REPROVADO ||
                (this.pagamento.status ===
                    pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO &&
                    !this.isFornecedor)
            )
        },

        isFornecedor() {
            return this.$route.name == 'FornecedorContratos_Pagamentos_Detalhar'
        }
    }
}
</script>
